"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.roundToTwo = void 0;
const roundToTwo = (num) => {
    return (num = Math.round(num * 100) / 100);
};
exports.roundToTwo = roundToTwo;
